export default __webpack_public_path__ + "static/media/goshen105.93aa9f96.jpg";